import { NavController, NavParams, ModalController, LoadingController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
// import { AuthenticationService } from "../../../authentication-service";
import { getDistanceInKM } from '../../../../globals';
// import {SelectCoursePage} from "../select-course/select-course";
import { ClubInfo, CourseInfo } from '../../../../data/club-course';
// import { GeolocationService } from "../../../providers/geolocation-service/geolocation-service";
// import { ClubService } from "../../../providers/club-service/club-service";
import { PerformanceClubListPage1 } from '../club-list1/club-list1.page';
import { HttpHeaders } from '@angular/common/http';
import { Apiurl } from '../../commonServices/route';
import { CommonProvider } from '../../commonServices/common';
import { Storage } from '@ionic/storage';
import { NavigationExtras, Router } from '@angular/router';
import { NewGameInfo } from '../../../../data/game-round';
import { ClubService } from 'src/providers/club-service/club-service';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';

/**
 * The competition list page class. This class lists the competitions. There are
 * three types of listing
 * <ul>
 *    <li>Upcoming</li>
 *    <li>All Competitions</li>
 *    <li>Search competitions</li>
 *  </ul>
 *  This class extends Subscriber which is passed as parameter for Remote Http method so that
 *  results are processed
 */
@Component({
  templateUrl: 'course-list.page.html',
  styleUrls: ['course-list.page.scss'],
})
export class PerformanceCourseListPage implements OnInit {
  public refresher: any;
  public infinite: any;

  public recentClubs: Array<ClubInfo>;
  public nearByClubs: Array<ClubInfo>;

  public selectedClub: ClubInfo;
  // public clubCourses: Array<CourseInfo> = [];
  clubCourses: any;

  public courseId: number;
  public courseName: string;

  public clubInfo: ClubInfo;
  public prevClubInfo: ClubInfo;
  token: string | string[];
  Userid: any;
  gameInfo: NewGameInfo;

  @Input() recentClubType: 'All' | 'Bookings' | 'Games' = 'All';

  constructor(
    private nav: NavController,
    private CommonProvider: CommonProvider,
    private modalCtl: ModalController,
    private storage: Storage,
    // private auth: AuthenticationService,
    private geo: GeolocationService,
    private clubService: ClubService,
    private router: Router,
    // private events: Events,
    // private viewCtrl: ViewController,
    private navParams: NavParams,
    private loadingCtl: LoadingController
  ) {
    this.recentClubs = new Array<ClubInfo>();
    this.nearByClubs = new Array<ClubInfo>();
    this.courseId = navParams.get('courseId');
    this.courseName = navParams.get('courseName');
    this.selectedClub = navParams.get('clubInfo');
    this.clubInfo = navParams.get('clubInfo');
    this.prevClubInfo = navParams.get('clubInfo');
    this.gameInfo = {
      courses: [],
      players: [],
      availablePlayers: [],
    };
  }
  // ngOnInit() {
  //   this.Getallcourses()
  // }

  async ngOnInit() {
    this.clubService.getClubCourses(this.selectedClub.clubId).subscribe(
      (courses: Array<CourseInfo>) => {
        this.clubCourses = courses;
      },
      error => {}
    );
  }

  /**
   * Gets the distance between a current location and club in KMs
   * @param club The club information
   * @returns {number} Returns the distance in KM if GPS locations of current and club are available
   * else returns 0;
   */
  clubDistance(club: ClubInfo): string {
    let lat1 = this.geo.getLatitude();
    let lon1 = this.geo.getLongitude();
    if (lat1 != null && lon1 != null && club.latitude != null && club.longitude != null)
      return getDistanceInKM(lat1, lon1, club.latitude, club.longitude) + ' KM';
    return '';
  }

  /**
   * Executed when refresh button on toolbar is clicked
   */
  onRefreshClick(refresher) {
    this.refresher = refresher;
    this._refreshValues();
  }

  courseSelected(event, item) {
    this.courseId = item.courseId;
    this.courseName = item.courseName;
    // this.router.navigate(['/tabs/performance'], {queryParams : { courseInfo: item, apply: true }})
    this.modalCtl.dismiss({ courseInfo: item, apply: true });
  }

  clubSelected(event, item: ClubInfo) {
    // this.events.publish("clubSelected", item);
    /*  this.nav.push(SelectCoursePage,{
     club: item
     });*/
    // let gameInfo: NavigationExtras = {
    //   state: {
    //     gameInfo: this.gameInfo
    //   }
    // };
  }

  async searchClubs() {
    let clubModal = await this.modalCtl.create({
      component: PerformanceClubListPage1,
      componentProps: {
        openedModal: true,
      },
    });

    clubModal.onDidDismiss().then((data: any) => {
      //Check whether the club info is passed
      if (data.clubInfo) {
        this.clubSelected(null, data.clubInfo);
      }
    });
    clubModal.present();
  }

  private async _refreshValues() {
    this.clubService.getNearbyClubs(3000).subscribe(
      (clubs: Array<ClubInfo>) => {
        this.nearByClubs = clubs;
      },
      error => {},
      () => {
        if (this.refresher) {
          this.refresher.complete();
          this.refresher = null;
        }
      }
    );

    this.clubService.getRecentClubs(5, this.recentClubType).subscribe(
      (clubs: Array<ClubInfo>) => {
        this.recentClubs = clubs;
      },
      error => {},
      () => {
        if (this.refresher) {
          this.refresher.complete();
          this.refresher = null;
        }
      }
    );

    // Nearby Clubs
  }

  close() {
    this.modalCtl.dismiss({ apply: false });
  }
}
